var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb30"},[(_vm.levelBankList)?_c('discount-rate-card',{attrs:{"type":_vm.type,"cuDiscountRate":_vm.cuDiscountRate,"levelBankList":_vm.levelBankList,"logo":_vm.logo}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e16b6fa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DiscountRateCardFm.vue
// module id = null
// module chunks = 